(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[672],{

/***/ 30258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Helmet; },
  "Z": function() { return /* binding */ components_Helmet; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/hooks/useBgByClass.ts

/**
 * 修改背景色
 */ const useBgByClass = function() {
    let className = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", container = arguments.length > 1 ? arguments[1] : void 0;
    (0,react.useEffect)(()=>{
        const classNameArr = className.trim() ? className.trim().split(/[ ]+/g) : [];
        if (!classNameArr.length || typeof document === "undefined") {
            return ()=>false;
        }
        const domContainer = container || document.body;
        if (!domContainer) {
            return ()=>false;
        }
        const containerClassList = domContainer.classList;
        containerClassList.add(...classNameArr);
        return ()=>containerClassList.remove(...classNameArr);
    }, [
        className,
        container
    ]);
};
/* harmony default export */ var hooks_useBgByClass = (useBgByClass);

;// CONCATENATED MODULE: ./src/components/Helmet.tsx




const Helmet = (param)=>{
    let { children , title ="" , bodyClassName ="" , htmlClassName ="" , keywords , description ="" , openGraph  } = param;
    /* 响应 body/html 上的 className 变更 */ hooks_useBgByClass(bodyClassName);
    hooks_useBgByClass(htmlClassName, typeof document === "undefined" ? undefined : document.getElementsByTagName("html")[0]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title || "Chereads: Fictional Stories Hub"
            }),
            bodyClassName && /*#__PURE__*/ (0,jsx_runtime.jsx)("body", {
                className: "vw100 ".concat(bodyClassName)
            }),
            htmlClassName && /*#__PURE__*/ (0,jsx_runtime.jsx)("html", {
                className: htmlClassName
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            keywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: openGraph.title
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: openGraph.description
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: openGraph.type
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: openGraph.url
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: openGraph.image
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.tag) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:tag",
                content: openGraph.tag
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.updatedTime) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:updated_time",
                content: openGraph.updatedTime
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.siteName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: openGraph.siteName
            }),
            (openGraph === null || openGraph === void 0 ? void 0 : openGraph.author) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:author",
                content: openGraph.author
            }),
            children
        ]
    });
};
/* harmony default export */ var components_Helmet = (Helmet);


/***/ }),

/***/ 3075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_IntersectionObserver; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/QDReport/index.tsx + 2 modules
var QDReport = __webpack_require__(73393);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/IntersectionObserver/observer.ts
const EVENT_COMMON_EXPOSURE_CHANGE = "common.exposure_change"; // 用于元素曝光检测
const GLOBAL_KEY = "_global";
const observers = {
    [GLOBAL_KEY]: undefined
};
const showEvent =  false ? 0 : new CustomEvent(EVENT_COMMON_EXPOSURE_CHANGE, {
    detail: {
        show: true
    }
});
const hideEvent =  false ? 0 : new CustomEvent(EVENT_COMMON_EXPOSURE_CHANGE, {
    detail: {
        show: false
    }
});
const callback = (entries, _observer)=>{
    entries.forEach((entry)=>{
        // Each entry describes an intersection change for one observed
        // target element:
        //   entry.boundingClientRect
        //   entry.intersectionRatio
        //   entry.intersectionRect
        //   entry.isIntersecting
        //   entry.rootBounds
        //   entry.target
        //   entry.time
        const { intersectionRatio , isIntersecting , target  } = entry;
        if (isIntersecting && intersectionRatio > 0.3) {
            target.dispatchEvent(showEvent);
        }
        if (!isIntersecting && intersectionRatio <= 0) {
            target.dispatchEvent(hideEvent);
        }
    });
};
const initObserver = (id)=>{
    const viewportEle = id ? document.getElementById(id) : null;
    if (id && !viewportEle) {
        throw Error("容器".concat(id, "不存在"));
    // return;
    }
    const options = {
        root: id ? viewportEle : null,
        rootMargin: "0px",
        threshold: [
            0,
            0.3
        ]
    };
    const key = id || GLOBAL_KEY;
    if (!observers[key]) {
        observers[key] = new IntersectionObserver(callback, options);
    }
};
const getObserver = function() {
    let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : GLOBAL_KEY;
    return observers[key];
};
const addObserver = function() {
    let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : GLOBAL_KEY, target = arguments.length > 1 ? arguments[1] : void 0;
    const observer = getObserver(key);
    if (target) {
        observer.observe(target);
    }
};
const removeObserver = function() {
    let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : GLOBAL_KEY, target = arguments.length > 1 ? arguments[1] : void 0;
    const observer = getObserver(key);
    if (target) {
        observer.unobserve(target);
    }
};

// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(50308);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ./src/components/IntersectionObserver/index.tsx





const IntersectionObserver_IntersectionObserver = (param)=>{
    let { Component ="div" , containerId , duration =1000 , onShow =(noop_default()) , once =false , report =null , children , ...otherProps } = param;
    const ref = (0,react.useRef)();
    const callbackTimer = (0,react.useRef)();
    const hasShown = (0,react.useRef)();
    const handleShow = ()=>{
        clearTimeout(callbackTimer.current);
        if (!once) {
            hasShown.current = true; // 重置 hasShown 以做到重复上报
        }
        callbackTimer.current = setTimeout(()=>{
            onShow();
            if (report) {
                (0,QDReport/* QDReportSender */.st)({
                    etype: "C",
                    ...report
                });
            }
        }, duration);
    };
    const handleToggleShow = (e)=>{
        const show = e.detail.show;
        if (show && !hasShown.current) {
            hasShown.current = true; // 重置 hasShown 以做到重复上报
            handleShow();
        } else {
            clearTimeout(callbackTimer.current);
            hasShown.current = false; // 重置 hasShown 以做到重复上报
        }
    };
    (0,react.useEffect)(()=>{
        var ref1;
        initObserver(containerId);
        addObserver(containerId, ref.current);
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener(EVENT_COMMON_EXPOSURE_CHANGE, handleToggleShow);
        return ()=>{
            var ref1;
            removeObserver(containerId, ref.current);
            (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener(EVENT_COMMON_EXPOSURE_CHANGE, handleToggleShow);
            clearTimeout(callbackTimer.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        ...otherProps,
        ref: ref,
        children: children
    });
};
/* harmony default export */ var components_IntersectionObserver = (IntersectionObserver_IntersectionObserver);


/***/ }),

/***/ 18648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42422);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const ResponsiveWrap = (param)=>{
    let { className ="" , children , maxWidth =900 , id  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: id,
        className: "".concat(className, " ").concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().container), " pr"),
        style: {
            maxWidth
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveWrap);


/***/ }),

/***/ 65378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ read_ui_Button; }
});

// UNUSED EXPORTS: ButtonSize

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@_nu/react-button/es/index.js
var es = __webpack_require__(75175);
// EXTERNAL MODULE: ./src/read-ui/_util/is.ts
var is = __webpack_require__(66783);
// EXTERNAL MODULE: ./src/read-ui/Button/style.module.scss
var style_module = __webpack_require__(40830);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/read-ui/Button/Button.tsx






const InternalButton = (param, ref)=>{
    let { size , ghost , flat , block , primary , loading , disabled , className ="" , classNameText ="" , children =null , ...otherProps } = param;
    const buttonRef = ref || /*#__PURE__*/ (0,react.createRef)();
    // class
    const buttonClassName = classnames_default()(className, (style_module_default()).button, {
        _fill: !ghost && !flat,
        _ghost: ghost,
        _xxs: (0,is.is)(size, "xxs"),
        _xs: (0,is.is)(size, "xs"),
        _sm: (0,is.is)(size, "sm"),
        _md: (0,is.is)(size, "md"),
        _lg: (0,is.is)(size, "lg"),
        _block: block,
        _primary: primary,
        _loading: loading,
        _disabled: disabled
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
        ref: buttonRef,
        disabled: !!disabled,
        className: buttonClassName,
        ...otherProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: classnames_default()((style_module_default()).text, classNameText, "db"),
            children: children
        })
    });
};
const Button = /*#__PURE__*/ (0,react.forwardRef)(InternalButton);
/* harmony default export */ var Button_Button = (Button);

// EXTERNAL MODULE: ./src/read-ui/_util/type.ts
var type = __webpack_require__(44024);
;// CONCATENATED MODULE: ./src/read-ui/Button/interfaces.ts

const ButtonSize = (0,type/* tuple */.b)("xxs", "xs", "sm", "md", "lg");

;// CONCATENATED MODULE: ./src/read-ui/Button/index.tsx


/* harmony default export */ var read_ui_Button = (Button_Button);


/***/ }),

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ read_ui_InputBox; }
});

// UNUSED EXPORTS: ButtonSize

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/read-ui/InputBox/style.module.scss
var style_module = __webpack_require__(23776);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/read-ui/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(7249);
// EXTERNAL MODULE: ./node_modules/@webnovel/chereads-icons/dist/react-icon.esm.js
var react_icon_esm = __webpack_require__(80717);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/read-ui/InputBox/inputBox.tsx







const InternalInputBox = (param, ref)=>{
    let { size , defaultValue ="" , className ="" , innerClassName ="" , children =null , onSearchChange , ...otherProps } = param;
    const inputBoxRef = ref || /*#__PURE__*/ (0,react.createRef)();
    // class
    const classNameRender = classnames_default()((style_module_default()).inputBox, {
        _sm: size === "sm",
        _md: size === "md",
        _lg: size === "lg"
    });
    const handleChange = (event)=>{
        const currKeyword = event.target.value; // 当前输入框的value
        // console.log('currKeyword', currKeyword)
        onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(currKeyword);
    };
    (0,react.useEffect)(()=>{
        inputBoxRef.current.value = defaultValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultValue
    ]);
    (0,react.useEffect)(()=>{
        const inputElement = inputBoxRef.current;
        window.onscroll = throttle_default()(()=>{
            if (!inputElement.value) {
                inputElement.blur();
            }
        }, 500);
        return ()=>{
            window.onscroll = null;
        };
    }, [
        inputBoxRef
    ]);
    const handleClear = ()=>{
        inputBoxRef.current.value = "";
        inputBoxRef.current.focus();
        onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange("");
    };
    // @ts-ignore
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className, " ").concat(classNameRender, " pr bsbb"),
        id: "j_search_group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((style_module_default()).search_label, " ").concat(classNameRender, " pa l0 t0 zi1 c_000"),
                htmlFor: "search",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    Svg: react_icon_esm/* SearchOutline */.rH,
                    className: "pa_auto w100% h100%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "search",
                ref: inputBoxRef,
                className: "".concat((style_module_default()).search_input, " ").concat(innerClassName, " ").concat(classNameRender, " _with_clear w100% bsbb c_l fw500 pt4 pb4 db"),
                type: "search",
                autoComplete: "off",
                defaultValue: defaultValue,
                ...otherProps,
                onChange: (e)=>handleChange(e)
            }, "input1"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "pa ".concat((style_module_default()).close, " ").concat(classNameRender, " ").concat(defaultValue ? "" : "dn", " clear_label r0 t50% c_l "),
                onClick: handleClear,
                title: "close",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    Svg: react_icon_esm/* Clear */.UZ,
                    className: "pa_auto w100% h100%"
                })
            })
        ]
    });
};
const InputBox = /*#__PURE__*/ (0,react.forwardRef)(InternalInputBox);
/* harmony default export */ var inputBox = (InputBox);

// EXTERNAL MODULE: ./src/read-ui/_util/type.ts
var type = __webpack_require__(44024);
;// CONCATENATED MODULE: ./src/read-ui/InputBox/interfaces.ts


// export const ButtonSize = tuple("small", "middle", "large");
const ButtonSize = (0,type/* tuple */.b)("sm", "md", "lg");

;// CONCATENATED MODULE: ./src/read-ui/InputBox/index.tsx


/* harmony default export */ var read_ui_InputBox = (inputBox);


/***/ }),

/***/ 25108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_REST; }
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/configs.ts
var configs = __webpack_require__(57066);
;// CONCATENATED MODULE: ./src/utils/Error.ts
class ErrorWithExtraInfo extends Error {
    constructor(msg, info){
        super(msg);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorWithExtraInfo);
        }
        this.info = info;
    }
}
/* harmony default export */ var utils_Error = (ErrorWithExtraInfo);

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./src/utils/REST.ts
/* eslint-disable */ /**
 * Created by liupeng on 2017/11/6.
 */ 





const MOCK_URL = "https://yapi.yuewen.com/mock/2309";
const parseJSON = (response)=>response.json();
const composeClientCgi = (url)=>{
    if (configs/* default.envType */.ZP.envType === "local") {
        if (/^\/go/.test(url)) {
            return "".concat(MOCK_URL).concat(url);
        }
    }
    return url;
};
let REST;
if (false) {}
if (true) {
    const Cookie = __webpack_require__(10646);
    const defaultData = {
        _csrfToken: Cookie.get("_csrfToken")
    };
    const defaultOptions = ()=>({
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "same-origin",
            // 设置10秒timeout
            timeout: 10000
        });
    const checkStatus = (url)=>(response)=>{
            if (response.status === 200) {
                // 上报正常状态
                return response;
            }
            if (response.status === 401) {
                // 登录
                return new Promise(()=>{});
            }
            const error = new utils_Error("REST checkStatus error: ".concat(response.status), response);
            // 上报请求错误至 YEP
            throw error;
        };
    const checkCode1 = (url)=>(json)=>{
            if (json.code === 0) {
                return json;
            }
            throw new utils_Error("REST checkStatus error: ".concat(json.code), {
                ...json,
                __url: url
            });
        };
    const fetchWithErrorHandle = (url, options)=>fetch(url, lodash_default().merge({}, defaultOptions(), options)).then(checkStatus(url)).then(parseJSON).then(checkCode1(url)).catch((err)=>{
            esm_exports/* captureException */.Tb(err);
            console.log("".concat(url, " 请求失败:"), err);
        });
    REST = {
        /**
     *
     * @param {String} url 请求url
     * @param {Object} data 请求参数
     * @param {Boolean} isOffStandardApi 是否为非标准返回的请求(有code标识请求结果)
     */ read (param) {
            let { url , data , options  } = param;
            // URL 带有 query 时进行拼接
            const mergedQuery = lodash_default().merge({}, defaultData, data);
            const mergedUrl = "".concat(composeClientCgi(url)).concat(url.includes("?") ? "&" : "?").concat(lib_default().stringify(mergedQuery));
            const mergedOptions = lodash_default().merge({
                method: "GET"
            }, options);
            return fetchWithErrorHandle(mergedUrl, mergedOptions);
        },
        create (param) {
            let { url , data , options  } = param;
            const stringifyData = lib_default().stringify(lodash_default().merge({}, defaultData, data));
            const mergedOptions = lodash_default().merge({}, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }, {
                body: stringifyData
            }, options);
            return fetchWithErrorHandle("".concat(composeClientCgi(url)), mergedOptions);
        },
        form (param) {
            let { url , data  } = param;
            return fetch(url, {
                method: "POST",
                credentials: "same-origin",
                body: data
            }).then(checkStatus(url)).then(parseJSON).then(checkCode1(url));
        }
    };
}
//@ts-ignore
/* harmony default export */ var utils_REST = (REST);


/***/ }),

/***/ 42422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__FGpEE"};

/***/ }),

/***/ 40830:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__YObZG","text":"style_text__lTyT6","ball-pulse":"style_ball-pulse__r2_k0"};

/***/ }),

/***/ 23776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search_input":"style_search_input__DrwWN","inputBox":"style_inputBox__dFWZk","search_label":"style_search_label__YAiVN","close":"style_close__kDPbH"};

/***/ })

}]);